import { render, staticRenderFns } from "./githubTool.html?vue&type=template&id=08589bda&scoped=true&"
import script from "./githubTool.js?vue&type=script&lang=js&"
export * from "./githubTool.js?vue&type=script&lang=js&"
import style0 from "./githubTool.scss?vue&type=style&index=0&id=08589bda&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08589bda",
  null
  
)

export default component.exports